// Only corporate emails are accepted in lead forms.
export const FREE_EMAIL_DOMAINS = [
  "gmail.com","googlemail.com","yahoo.com","yahoo.co.in","yahoo.co.uk","ymail.com","rocketmail.com",
  "hotmail.com","outlook.com","live.com","msn.com","icloud.com","me.com","mac.com","aol.com",
  "proton.me","protonmail.com","gmx.com","gmx.de","gmx.net","mail.com","zoho.com","zohomail.in",
  "yandex.ru","yandex.com","ya.ru","mail.ru","bk.ru","inbox.ru","list.ru","rambler.ru",
  "qq.com","163.com","126.com","sina.com","foxmail.com","rediffmail.com","hotmail.co.uk",
  "outlook.in","live.in","yahoo.com.tr","hotmail.com.tr","windowslive.com","tutanota.com","hey.com",
];

export function isFreeEmail(email: string): boolean {
  const d = email.trim().toLowerCase().split("@")[1];
  return !!d && FREE_EMAIL_DOMAINS.includes(d);
}

function message(): string {
  const lang = (document.documentElement.lang || "en").slice(0, 2);
  if (lang === "tr") return "Lütfen kurumsal e-posta adresinizi girin (ör. ad@sirketiniz.com). Gmail, Yahoo, Outlook vb. kabul edilmez.";
  if (lang === "hi") return "कृपया अपनी कंपनी का ईमेल दर्ज करें (जैसे name@yourcompany.com)। Gmail, Yahoo, Outlook आदि स्वीकार नहीं हैं।";
  return "Please use your corporate email (e.g. name@yourcompany.com). Gmail, Yahoo, Outlook and other personal addresses are not accepted.";
}

function onAgents() {
  return window.location.pathname.startsWith("/agents");
}

function check(el: EventTarget | null) {
  if (!onAgents()) return;
  if (!(el instanceof HTMLInputElement) || el.type !== "email") return;
  el.setCustomValidity(el.value && isFreeEmail(el.value) ? message() : "");
}

/** Blocks form submission with a native hint when a personal email is entered. */
export function installCorpEmailGuard() {
  if (typeof document === "undefined") return;
  document.addEventListener("input", (e) => check(e.target), true);
  document.addEventListener("change", (e) => check(e.target), true);
  document.addEventListener("submit", (e) => {
    if (!onAgents()) return;
    const form = e.target as HTMLFormElement;
    form.querySelectorAll<HTMLInputElement>('input[type="email"]').forEach(check);
    if (!form.checkValidity()) {
      e.preventDefault();
      e.stopImmediatePropagation();
      form.reportValidity();
    }
  }, true);
}
